(function HotelEngineHotelDetails($, Adzuki)
{
	"use strict";

	var map    = null;
	var $modal = $('#modalWindow');

	$(document).ready(function documentReady()
	{
		var pages = [
			'HotelEngine/hotelDetails',
			'HotelEngine/displayBooking'
		];

		var max_time      = 600, // max amount of seconds before we say to retry
			current_timer = 0,
			interval;

		Adzuki.onload(pages, function onload()
		{
			$('.ajax-image-gallery').click(function _showGallery() {
				var $el            = $(this),
					index          = parseInt($(this).data('index')),
					hotel_gallery  = null,
					url            = '/HotelEngine/getGalleryImages/',
					giata_id       = $el.data('giata-id') || $el.parent().data('giata-id');

				if (Adzuki.init_page === 'HotelEngine/hotelDetails') {
					if (!giata_id) {
						throw new Error('missing giata-id');
					}

					url += giata_id;
				}

				// hit a different ajax url if on the Hotel Enging Booking Completed screen
				if (Adzuki.init_page === 'HotelEngine/displayBooking') {
					url = '/HotelEngine/getBookingGalleryImages/';
				}

				Adzuki.Ajax.post(url).then(function sucess(response) {
					var images         = response;
					var gallery_images = [];

					if (images.length === 0) {
						return;
					}

					$.each(images, function onEachImage(i, image) {
						gallery_images.push({
							src    : image.src,
							thumb  : image.thumb,
							subHtml: image.subHtml,
						});
					});

					hotel_gallery = lightGallery($el[0], {
						licenseKey       : 'github',
						download         : false,
						plugins          : [lgThumbnail],
						dynamic          : true,
						thumbnail        : true,
						toggleThumb      : true,
						allowMediaOverlap: true,
						index            : index,
						dynamicEl        : gallery_images,
					});

					hotel_gallery.openGallery();
				});
			});

			$('.hotel-engine-room-image').click(function _showRoomGallery() {
				var	room_gallery = null,
					$self        = $(this),
					image_json   = $self.data('gallery-images');

				room_gallery = lightGallery($self[0], {
					licenseKey       : 'github',
					download         : false,
					plugins          : [lgThumbnail],
					dynamic          : true,
					thumbnail        : true,
					toggleThumb      : true,
					allowMediaOverlap: true,
					dynamicEl        : image_json,
				});

				room_gallery.openGallery();
			});

			$('.rate-select').on('change', function swapRate() {
				var $self       = $(this),
				    $room       = $self.closest('.hotel-engine-room'),
				    $select     = $room.find('a.select-rate'),
				    data        = $self.data(),
				    booking_uri = '/HotelEngine/processor/selectRoom/' + data['rateSelect'];

				$room.find('.per-night').html(data['nightly']);
				$room.find('.taxes-fees').html(data['taxesFees']);
				$room.find('.savings-pct').html(data['savings']);
				$room.find('.selling-price').html(data['sellingPrice']);

				// Update booking link
				$select.attr('href', Adzuki.get_url(booking_uri));
				$select.attr('data-uri', Adzuki.get_url(booking_uri));
			});

			$('.hotel-engine-room-additional-rate-label').on('click', function _showAdditionalRates(e) {
				var additional_rate_key  = $(this).data('additional-rates'),
					additional_room_name = $(this).data('additional-room'),
					$btn                 = $(this),
					original_text        = $btn.html();

				$btn.html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin"></i>&nbsp;Fetching rates...');
				$modal.find('.modal-title').text(additional_room_name);
				$modal.find('.modal-dialog').addClass('modal-lg');

				Adzuki.Ajax.get('/HotelEngine/rates/' + additional_rate_key)
				.then(function _saveNote(content) {
					$modal.find('.modal-body').html(content);

					if ($('#lightgallery-inline').length > 0) {
						Adzuki.Erez.AllInclusiveProperties.ImageGallery();
					}

					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');

					$btn.html(original_text);
				});
			});

			$modal.on('click', '.rate-details', function _showRateDetals(e) {
				var index        = $(this).data('index'),
					details      = $(this).data('details'),
					raw          = JSON.stringify($(this).data('raw'), null, 2),
					more_details = $(this).data('more-details'),
					policies     = $(this).data('policies');
				
				e.preventDefault();

				// reset the row color
				$('.rate-row').each(function _itierateRow(key, val) {
					if (key % 2 === 0) {
						$(this).css('background-color', '#f9f9f9');
					} else {
						$(this).css('background-color', '#ffffff');
					}
				});

				$('.rate-row[data-index="' + index + '"]').css('background-color', '#CDE4F7');
				$('.rate-detail-information').html(details);
				$('.rate-detail-raw').html('<h4>Rate Data</h4><pre><code>' + raw + '</code></pre>');
				$('#more_details').html('<div class="pad10">' + more_details + '</div>');
				$('#policies').html('<div class="pad10">' + policies + '</div>');
			});

			loadMap();
			loadReviews();
			initSpecialtyBadges();

			interval = setInterval(
				function _updateCurrentTimer() {
					// console.log(current_timer);

					if (current_timer >= max_time) {
						clearInterval(interval);

						Adzuki.CustomConfirm({
							title  : 'Decision Time',
							content: 'You have been on this page longer than ' + max_time/60 + ' minutes. It is recommended to reload this hotel\'s details. Would you like to reload it now?',
							confirm: function confirm() {
								document.location = Adzuki.base_uri + '/HotelEngine/processor/selectHotel/' + $('#giata_id').val();
							}
						});
					}

					current_timer++;
				},
				1000
			);

			showSpecialtyRates();
		});
	});

	function initSpecialtyBadges()
	{
		$('.specialty-badge').on('click', function click(e) {
			e.preventDefault();

			$modal.find('.modal-title').text('SPECIALTY RATE PROGRAM');
			$modal.find('.modal-body').html('<span class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-2x fa-spin"></span> Retrieving specialty rate information...');
			$modal.modal('show');

			Adzuki.Ajax.get('/HotelEngine/loadSpecialtyRateDetails/' + encodeURIComponent($(this).data('sabre-hotel-id')) + '/' + encodeURIComponent($(this).data('rate-code')))
			.then(function content(content) {
				$modal.find('.modal-body').html(content);
			});
		});
	}

	function loadMap()
	{
		if (map === null) {
			map = new Adzuki.Map(
				$('.hotel-map'), {
					zoom: 15,
					init: function map_init(_map) {
						_map.populate($('.hotel-map').data('map-markers'));
					}
				}
			);
		}
	}

	function loadReviews()
	{
		var giata_id = $('#giata_id').val();

		if (giata_id) {
			Adzuki.Ajax.get('/HotelEngine/reviews/' + giata_id)
			.then(function success(response) {
				$('.review-content').html(response);
			});
		}
	}

	function showSpecialtyRates()
	{
		if ($('#show-specialty-rates').length > 0 && parseInt($('#show-specialty-rates').data('value')) === 1) {
			if ($('#specialty-rate-tab').length > 0) {
				$('#specialty-rate-tab').trigger('click');
			} else {
				Adzuki.StatusMessage('warning', 'Unfortunately the selected hotel does not currently have any available specialty rates. All other available rates are shown instead.');
			}
		}
	}
}(jQuery, window.Adzuki || {}));
